import BillingsTaxiTaxiDetailsRequest from "../../../../api/raily/billings/taxi-taxi/details/billings-taxi-taxi-details.request";
import BillingsTaxiTaxiDetailsParams from "./billings-taxi-taxi-details-params";

const createRequest = (
  params: BillingsTaxiTaxiDetailsParams,
): BillingsTaxiTaxiDetailsRequest => {
  return {
    billingUuid: params.billingUuid,
  };
};

const billingsTaxiTaxiDetailsParamsFactory = {
  createRequest,
};

export default billingsTaxiTaxiDetailsParamsFactory;
